import { Link } from 'react-router-dom';
import type { MailListItem } from '../api/client';
import { formatDate } from '../api/client';

interface Props {
  items: MailListItem[];
  activeId?: string | null;
  basePath?: string;
}

export default function MailList({ items, activeId, basePath = '/mail' }: Props) {
  if (!items.length) {
    return <div className="empty">暂无邮件</div>;
  }

  return (
    <div className="mail-list">
      {items.map((m) => (
        <Link
          key={m.id}
          to={`${basePath}/${m.id}`}
          className={`mail-item ${activeId === m.id ? 'active' : ''}`}
        >
          <div className="subject">{m.subject || '(no subject)'}</div>
          <div className="meta">
            <span title={m.from}>{m.from || '-'}</span>
            <span>{formatDate(m.receivedAt)}</span>
          </div>
          <div className="meta" style={{ marginTop: 6 }}>
            <span>{m.mailbox}</span>
            {m.hasAttachment ? <span className="badge att">附件</span> : <span />}
          </div>
        </Link>
      ))}
    </div>
  );
}
